module.exports = __webpack_public_path__ + "gm992021/img/qiji-6.png?40d3d7ab";